export default __webpack_public_path__ + "static/media/dm-invite.b7e99c68.svg";